export default __webpack_public_path__ + "static/media/acrepairguy2.855f8ef7.webp";